import React from "react";
import EventOdd from "./EventOdd";
import { Button, Icon, Popover, Select } from "antd";
import { connect } from "react-redux";
import { getSuggestedBalls } from "../../../redux/actions/sportTypesActions";
import { updateBetSlip } from "../../../redux/actions/betSlipActions";
import { SessionStorage } from "../../../helpers";
import EventOddField from "./EventOddField";
import Images from "../Images";
const Option = Select.Option;

class EventOddGroup extends React.Component {
  state = {
    selectedBalls: [],
    bonusBalls: [],
  };
  componentDidUpdate(prevProps) {
    const { suggestedBalls, eventId, groupId, group } = this.props;
    // && this.state.oddField && this.state.oddField.betType.betTypeGroupId == groupId
    if (suggestedBalls && prevProps.suggestedBalls !== suggestedBalls) {
      let mainBalls = suggestedBalls.filter((item) => item.ballType == 1);
      let bonusBalls = suggestedBalls.filter((item) => item.ballType == 2);
      let mainSelectedBalls =
        mainBalls && mainBalls.length > 0
          ? mainBalls.map((item) => {
              return item.ballValue;
            })
          : [];
      let mainBonusBalls =
        bonusBalls && bonusBalls.length > 0
          ? bonusBalls.map((item) => {
              return item.ballValue;
            })
          : [];
      if (this.state.betTypeGroupId) {
        this.setState({
          selectedBalls: mainSelectedBalls,
          bonusBalls: mainBonusBalls,
          oddField: this.state.oddField,
          betTypeGroupId: undefined,
        });
      }
    }
  }
  filterRows = (value) => {
    this.setState({
      filter: value,
    });
  };
  openBallsContainer = (
    GroupName,
    oddFieldId,
    oddField,
    selectedBalls,
    bonusBalls,
    ballColor
  ) => {
    this.setState({
      betTypeGroupName: GroupName,
      activeOddFieldId: oddFieldId,
      oddField,
      selectedBalls,
      bonusBalls,
      ballColor,
    });
  };
  generateBonusBallArray = (range) => {
    const [start, end] = range.split("-").map(Number);
    let ballsArray = [];

    for (let i = start; i <= end; i++) {
      ballsArray.push(i);
    }
    return ballsArray;
  };
  onSelectBall = (oddFieldNumber, value) => {
    if (this.state.selectedBalls.length == oddFieldNumber) return;
    let newSelectedBalls = this.state.selectedBalls;
    newSelectedBalls.push(value);
    this.setState({ ballColor: undefined, selectedBalls: newSelectedBalls });
  };
  removeSelected = (value) => {
    let selectedBalls = this.state.selectedBalls;
    const newArray = selectedBalls.filter((item) => item !== value);
    this.setState({ selectedBalls: newArray });
  };
  onSelectBonus = (value) => {
    const { bounosBallCount } = this.props;
    if (this.state.bonusBalls.length == bounosBallCount) return;
    let newBonusBalls = this.state.bonusBalls;
    newBonusBalls.push(value);
    this.setState({ ballColor: undefined, bonusBalls: newBonusBalls });
  };
  removeSelectedBonus = (value) => {
    let bonusBalls = this.state.bonusBalls;
    const newBonusBalls = bonusBalls.filter((item) => item !== value);
    this.setState({ bonusBalls: newBonusBalls });
  };
  loadBalls = (Selection, TypeId, eventId, betTypeGroupId) => {
    const { match, getSuggestedBalls } = this.props;
    let request = {
      Data: {
        Feed: { FeedId: Number(match.params.feed) },
        Sport: { SportId: Number(match.params.sport) },
        EventId: eventId,
        Selection: Selection,
        TypeId: TypeId,
        BetTypeId: this.state.oddField.betType.betTypeId,
      },
    };
    this.setState({
      ballColor: TypeId == 1 ? "#0F4B9E" : TypeId == 2 ? "#E01B22" : "#28AF00",
      eventId,
      betTypeGroupId,
    });
    getSuggestedBalls(request);
  };
  onFieldClick(e, field) {
    const { drawEvents } = this.props;
    e.preventDefault();
    e.stopPropagation();
    let betSlipField = {
      ...field,
      selectedNumbers:
        this.state.selectedBalls.length > 0
          ? this.state.selectedBalls.join(",")
          : null,
      selectedBonuses:
        this.state.bonusBalls.length > 0
          ? this.state.bonusBalls.join(",")
          : null,
      drawEvents: drawEvents,
      selectedDraws: drawEvents && drawEvents[0] && [drawEvents[0]],
      selectedDrawsIds: drawEvents && drawEvents[0] && [drawEvents[0].eventId],
    };

    const { updateBetSlip } = this.props;
    let betTab = SessionStorage.betTab;
    if (betTab == 1) {
      updateBetSlip({
        ...betSlipField,
        amount: (!this.props.hideStake && this.props.amount) || 100,
      });
    } else {
      updateBetSlip(betSlipField);
    }
  }
  containsEnglishLetter(str) {
    if(!str) return false
    return /[a-zA-Z].*[a-zA-Z]/.test(str);
  }
  
  render() {
    const {
      eventEnabled,
      group,
      eventId,
      groupId,
      selectedTab,
      fromDrillDown,
      fromLuckyNumbers,
      ballCount,
      bounosBallRange,
      bounosBallCount,
      suggestedBalls,
      drawEvents,
      specialOddFieldGroup,
    } = this.props;
    const ballArray = ballCount && Array.from(Array(ballCount).keys());
    if (selectedTab !== group.betTypeDrillDownGroupName) {
      //if not equal to selected tab don't render
      return null;
    }
    // condition for displaying specialOdd field coloumn
    // {fromDrillDown && odd && odd.betType.separateOddSpecialField && (
    //   <div className="odd-special-field-container">{odd.oddSpecialField}</div>
    // )}
    // end of condition for displaying specialOdd field coloumn

    const {
      groupOdds,
      isSpecialGroup,
      specialTemplateName,
      specialOddFields,
      betTypeHint,
      betTypeHintText
    } = this.getOddsForGroup(groupId);
    // const defaultValue =
    //   groupOdds &&
    //   Object.entries(groupOdds).length > 0 &&
    //   Object.entries(groupOdds)[0][1].oddSpecialField;
    let filteredGroupOdds = {};
    let filterValues = Object.values(groupOdds).map((item) => {
      return fromLuckyNumbers ? item.betType.betTypeId : item.oddSpecialField;
    });
    filterValues = filterValues.filter(
      (value, index, my_arr) => my_arr.indexOf(value) == index
    );
    filterValues.map((item) => {
      Object.entries(groupOdds).map((ele) => {
        if (fromLuckyNumbers) {
          if (item == ele[1].betType.betTypeId && filteredGroupOdds[item]) {
            filteredGroupOdds[item][ele[0]] = ele[1];
          } else if (
            item == ele[1].betType.betTypeId &&
            !filteredGroupOdds[item]
          ) {
            filteredGroupOdds[item] = {};
            filteredGroupOdds[item][ele[0]] = ele[1];
          }
        } else {
          if (item == ele[1].oddSpecialField && filteredGroupOdds[item]) {
            filteredGroupOdds[item][ele[0]] = ele[1];
          } else if (
            item == ele[1].oddSpecialField &&
            !filteredGroupOdds[item]
          ) {
            filteredGroupOdds[item] = {};
            filteredGroupOdds[item][ele[0]] = ele[1];
          }
        }
      });
    });
    // let filteredGroupOdds = {};
    // if (true) {
    //   filteredGroupOdds = Object.entries(groupOdds).filter((odd) => {
    //     return (
    //       odd[1].oddSpecialField ==
    //       (this.state.filter ? this.state.filter : Object.entries(groupOdds)[0][1].oddSpecialField)
    //     );
    //   });
    // } else {
    // }
    return (
      <div className="group">
        {
          <div className="title-wrapper">
              <div className="title">
                {specialTemplateName ? specialTemplateName : group.betTypeGroupName}
              </div>
              {betTypeHint && <Popover
                  overlayClassName="info-pop-over"
                  placement="bottomRight"
                  arrowPointAtCenter
                  content={<div style={{fontSize:"10px" , maxWidth:"213px"}}>{betTypeHintText} </div>}
                  trigger="click"
                  arrowContent={<div style={{ borderColor: "red" }} />}
                >
                 <img src={Images.InfoCircle} alt="info-circle"/> 
               </Popover>}
          </div>
        }
        {/* <div className="drill-down-filter">
          <Select
            //   onSelect={this.loyalityRewardDroppDown}
			onSelect={this.filterRows}
            className="loyality-rewards-select"
            defaultValue={
              <div className="select-default-value">{defaultValue}</div>
            }
          >
            {filterValues.map((item) => {
              return (
                <Option className="select-options" key={item} value={item}>
                  <span className="select-default-value">{item}</span>
                </Option>
              );
            })}
          </Select>
        </div> */}
        {Object.entries(filteredGroupOdds).length > 0 &&
          groupOdds &&
          Object.entries(filteredGroupOdds).map((groupEle) => {
            return (
              <>
                {fromLuckyNumbers &&
                  Object.values(groupEle[1]) &&
                  Object.values(groupEle[1])[0] &&
                  Object.values(groupEle[1])[0].betType &&
                  Object.values(groupEle[1])[0].betType.betTypeName && (
                    <div className="group-subtitle">
                      {Object.values(groupEle[1])[0].betType.betTypeName}
                    </div>
                  )}

                <div className="drill-down-special-odd-field-container">
                  {Object.values(groupEle[1]).length > 0 &&
                    Object.values(groupEle[1])[0].betType
                      .separateOddSpecialField && (
                      <div
                        className="odd-field-container"
                        style={
                          this.containsEnglishLetter(groupEle[0])
                            ? {
                                width: "33%",
                                minWidth: "unset",
                                whiteSpace: "unset",
                                overflow: "auto",
                                textOverflow: "unset",
                              }
                            : {}
                        }
                      >
                        {groupEle[0]}
                      </div>
                    )}
                  {isSpecialGroup && (
                    <div className="container" style={{ width: "100%" }}>
                      {specialOddFieldGroup &&
                        Object.values(specialOddFieldGroup) &&
                        Object.values(specialOddFieldGroup).length > 0 &&
                        Object.values(specialOddFieldGroup).map(
                          (oddFieldRow) => {
                            return (
                              <div
                                className="special-odd-group-container"
                              >
                                <div
                                  className="special-odd-group-container-value"
                                >
                                  {oddFieldRow[0].oddField}
                                </div>
                                <div
                                  className="buttons-ods drilldown-buttons-container"
                                  style={{ display: "flex" ,width:"67%"}}
                                >
                                  {oddFieldRow.map((eventOddField) => {
                                    return (
                                      <EventOddField
                                        fromDrillDown={fromDrillDown}
                                        eventId={eventId}
                                        oddId={`${eventOddField.betType.betTypeGroupId}_${eventOddField.oddSpecialField}`}
                                        activeOddFieldId={this.state.activeOddFieldId}
                                        oddFieldId={eventOddField.activeOddFieldId}
                                        showDetails
                                        showOddName
                                      />
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          }
                        )}
                    </div>
                  )}
                  {!isSpecialGroup &&
                    Object.keys(groupEle[1]).map((key, idx) => (
                      <div key={key} className={`odd-field-sibling-container`}>
                        <EventOdd
                          openBallsContainer={this.openBallsContainer}
                          activeOddFieldId={this.state.activeOddFieldId}
                          betTypeGroupName={group.betTypeGroupName}
                          ballCount={ballCount}
                          fromDrillDown={fromDrillDown}
                          eventEnabled={eventEnabled}
                          showDetails
                          showOddName
                          oddId={key}
                          eventId={eventId}
                          drawEvents={drawEvents}
                        />
                      </div>
                    ))}
                </div>
              </>
            );
          })}
        {fromLuckyNumbers &&
          this.state.betTypeGroupName === group.betTypeGroupName && (
            <div className="lucky-numbers-draw-details">
              <div className="lucky-balls-buttons">
                <div>
                  Predict balls that will be extracted from the ballset.
                </div>
                <div>
                  <Button
                    className="cold"
                    onClick={() =>
                      this.state.oddField &&
                      this.loadBalls(
                        this.state.oddField.oddFieldNumber,
                        1,
                        this.state.oddField.eventId,
                        group.betTypeGroupId
                      )
                    }
                  >
                    Cold numbers
                  </Button>{" "}
                  <Button
                    className="hot"
                    onClick={() =>
                      this.state.oddField &&
                      this.loadBalls(
                        this.state.oddField.oddFieldNumber,
                        2,
                        this.state.oddField.eventId,
                        group.betTypeGroupId
                      )
                    }
                  >
                    Hot Numbers
                  </Button>{" "}
                  <Button
                    className="quick"
                    onClick={() =>
                      this.state.oddField &&
                      this.loadBalls(
                        this.state.oddField.oddFieldNumber,
                        3,
                        this.state.oddField.eventId,
                        group.betTypeGroupId
                      )
                    }
                  >
                    Quick pick
                  </Button>
                </div>
              </div>
              {ballArray && this.state.oddField && (
                <>
                  <div className="heading">Main Numbers</div>

                  <div className="lucky-number-balls-container">
                    {ballArray.map((item) => {
                      return (
                        <div
                          className={`balls ${this.state.selectedBalls.includes(
                            item + 1
                          ) && `selected`} ${!this.state.selectedBalls.includes(
                            item + 1
                          ) &&
                            this.state.oddField.oddFieldNumber ==
                              this.state.selectedBalls.length &&
                            `disallowed`}`}
                          key={item}
                          onClick={() =>
                            this.state.selectedBalls.includes(item + 1)
                              ? this.removeSelected(item + 1)
                              : this.onSelectBall(
                                  this.state.oddField.oddFieldNumber || 0,
                                  item + 1
                                )
                          }
                        >
                          {item + 1}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {this.state.oddField &&
                this.state.oddField.betType &&
                this.state.oddField.betType.betTypeId == 3 &&
                bounosBallRange && (
                  <>
                    <div className="heading">Bonus Balls</div>
                    <div className="lucky-number-balls-container">
                      {this.generateBonusBallArray(bounosBallRange).map(
                        (item) => {
                          return (
                            <div
                              className={`balls ${this.state.bonusBalls.includes(
                                item
                              ) &&
                                `bonus-selected`} ${!this.state.bonusBalls.includes(
                                item
                              ) &&
                                this.state.bonusBalls.length ==
                                  bounosBallCount &&
                                `disallowed`}`}
                              key={item}
                              onClick={() =>
                                this.state.bonusBalls.includes(item)
                                  ? this.removeSelectedBonus(item)
                                  : this.onSelectBonus(item)
                              }
                            >
                              {item}
                            </div>
                          );
                        }
                      )}
                    </div>
                  </>
                )}

              {(this.state.selectedBalls.length > 0 ||
                this.state.bonusBalls.length > 0) &&
                this.state.oddField && (
                  <>
                    <div className="heading">Your Selection</div>
                    <div className="lucky-number-balls-container">
                      <div className="selection-button-container">
                        <div className="selection-balls">
                          {this.state.selectedBalls.map((item) => {
                            return (
                              <div
                                className={`balls ${this.state.selectedBalls.includes(
                                  item
                                ) && `selected`}`}
                                style={
                                  this.state.selectedBalls.includes(item) &&
                                  this.state.ballColor
                                    ? { backgroundColor: this.state.ballColor }
                                    : {}
                                }
                                key={item}
                              >
                                {item}
                              </div>
                            );
                          })}
                          {this.state.bonusBalls.map((item) => {
                            return (
                              <div
                                className={`balls ${this.state.bonusBalls.includes(
                                  item
                                ) && `bonus-selected`}`}
                                key={item}
                              >
                                {item}
                              </div>
                            );
                          })}
                        </div>
                        <div className="buttons-container">
                          <div>
                            <Button
                              className="clear-button"
                              onClick={() => {
                                this.setState({
                                  selectedBalls: [],
                                  bonusBalls: [],
                                  ballColor: undefined,
                                });
                              }}
                            >
                              CLEAR
                            </Button>
                          </div>
                          <div>
                            {this.state.selectedBalls.length ==
                              this.state.oddField.oddFieldNumber && (
                              <Button
                                className="add-button"
                                onClick={(e) =>
                                  this.onFieldClick(e, this.state.oddField)
                                }
                              >
                                ADD
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </div>
          )}
      </div>
    );
  }

  getOddsForGroup(groupKey) {
    const { odds , specialOddFieldGroup} = this.props;
    const specialgroups = this.props.specialGroupOdds;
    let isSpecialGroup = false;
    let specialTemplateName = null;
    let betTypeHint = null;
    let betTypeHintText = null;
    let groupOdds = {};
    odds &&
      Object.keys(odds).map((key) => {
        if (
          specialOddFieldGroup && Object.values(specialOddFieldGroup) && Object.values(specialOddFieldGroup).length > 0 && odds[key].betType.specialTemplateName &&
          `${odds[key].betType.betTypeGroupId}_${odds[key].betType.betTypeGroupName}` ===
            groupKey
        ) {
          isSpecialGroup = true;
          specialTemplateName = odds[key].betType.specialTemplateName;
          betTypeHint = odds[key].betType.betTypeHint;
          betTypeHintText = odds[key].betType.betTypeHintText;
        } else
        if (
          `${odds[key].betType.betTypeGroupId}_${odds[key].betType.betTypeGroupName}` ===
          groupKey
        ) {
          groupOdds[key] = odds[key];
          betTypeHint = odds[key].betType.betTypeHint;
          betTypeHintText = odds[key].betType.betTypeHintText;
        }
      });

    return !isSpecialGroup
      ? { groupOdds, isSpecialGroup, specialTemplateName , betTypeHint , betTypeHintText}
      : { groupOdds: specialgroups, isSpecialGroup, specialTemplateName , betTypeHint , betTypeHintText };
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    group: state.sportEvents.eventOddGroups[initialProps.groupId],
    odds: state.sportEvents.eventOdds[initialProps.eventId],
    suggestedBalls: state.sportTypes.suggestedBalls,
    specialGroupOdds: state.sportEvents.specialGroupOdds,
    specialOddFieldGroup: state.sportEvents.specialOddFieldGroup,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSuggestedBalls: (request) => {
      dispatch(getSuggestedBalls(request));
    },
    updateBetSlip: (field) => {
      dispatch(updateBetSlip(field));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EventOddGroup);
